import View from './View';

export { default as View, getPickerItemStyles } from './View';
export const useViewModel = (props) => props;

export default View;
